import type { StageConfig } from '@capture/shared';
import { StageDeepLinks } from './StageDeepLinks';

export function PreExportPanel({ config: _config, onChange: _onChange }: { config: StageConfig; onChange: (c: StageConfig) => void }) {
  return (
    <div className="stage-panel">
      <p>Pre-export transforms run after verification, before export.</p>
      <StageDeepLinks stage="pre-export" />
    </div>
  );
}
